module.exports = __webpack_public_path__ + "img/nav_mobil_menu_close.10db47be.svg";